import { useState } from 'react';
import { HubCheckinProvider } from '../../contexts/HubCheckinProvider';
import LiveCheckinContent from './LiveCheckinContent';
import { LiveCheckinDataContextProvider } from './useLiveCheckInDataContext';
import { useCommonContext } from '../../contexts/common';
import { Box } from '@primer/react';
import { default as Text } from "../../components/ui/text";
const LiveCheckinPage = () => {
    const { checkAccesiableTo } = useCommonContext();
    const canView = checkAccesiableTo(`food/live-checkin/select`, "POST");

    if (!canView) {
        return (
            <Box sx={{ textAlign: "center", padding: 4 }}>
                <Text sx={{fontWeight:'bold'}} text="BẠN KHÔNG CÓ QUYỀN XEM" />
            </Box>
        );
    }

    return (
        <HubCheckinProvider>
            <LiveCheckinDataContextProvider>
                <LiveCheckinContent />

            </LiveCheckinDataContextProvider>
        </HubCheckinProvider >
    );
};

export default LiveCheckinPage;